import React, { useEffect } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { formSchema } from "./schemas/index";
import { useTranslation } from "react-i18next";
import { ScreenContainer, TextField, ToggleButtons } from "../../components";
import './Form.scss';

const Form = () => {
  const { t } = useTranslation();

  const formData = JSON.parse(localStorage.getItem("formData"))

  const initialValues = {
    name: formData?.name ? formData?.name : "",
    age: formData?.age ? formData?.age : "",
    gender: formData?.gender ? formData?.gender : "",
  };
  const Navigate = useNavigate();
  const schema = formSchema(t);
  const { values, errors, handleBlur, handleChange: onChange, setFieldValue, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: schema,
      validateOnChange: false,
      onSubmit: (values, action) => {
        action.resetForm();
        localStorage.setItem("formData", JSON.stringify(values));
        Navigate("/dignosisIntro");
      },
    });
  useEffect(() => {
    if (values.name && values.age && values.gender) {
      setTimeout(handleSubmit, 2000);
    }
  }, [values, handleSubmit])
  return (
    <ScreenContainer>
      <div className="FormScreenContainer">
        <TextField label={t("label1")} value={values.name} error={errors.name} handleBlur={handleBlur} name="name" onChange={onChange} />
        <TextField label={t("label2")} value={values.age} error={errors.age} handleBlur={handleBlur} name="age" onChange={onChange} />
        <ToggleButtons value={values.gender} name="gender" error={errors.gender} onChange={setFieldValue} buttons={[{ label: t("genderList1"), value: 'male' }, { label: t("genderList2"), value: 'female' }]} />
      </div>
    </ScreenContainer>
  );
};

export default Form;
